// src/utils/axios.js
import axios from 'axios';

const api = axios.create({
  // Desarrollo se conecta al backend local. La compilación de producción
  // usa el dominio configurado en REACT_APP_API_URL.
  baseURL: process.env.NODE_ENV === 'production'
    ? (process.env.REACT_APP_API_URL || 'https://pcvasquez.com/api')
    : 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token de autenticación
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas de error - MODIFICADO
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      console.log('Sesión expirada - Redirección manejada por ProtectedRoute');
      // ✅ Removida la redirección automática a login
    }
    return Promise.reject(error);
  }
);

// Servicios de Autenticación
export const authAPI = {
  login: (credentials) => api.post('/users/login', credentials),
  register: (userData) => api.post('/users/register', userData),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },
  getProfile: () => api.get('/users/profile'),
  updateProfile: (userData) => api.put('/users/profile', userData),
};

// Servicios de Favoritos
export const favoritesAPI = {
  getFavorites: () => api.get('/users/favorites'),
  toggleFavorite: (productId) => api.post(`/users/favorites/${productId}`),
  removeFavorite: (productId) => api.delete(`/users/favorites/${productId}`)
};

// Servicios de Órdenes
export const ordersAPI = {
  getAllOrders: (params = {}) => api.get('/orders', { params }),
  getOrderById: (id) => api.get(`/orders/${id}`),
  createOrder: (orderData) => api.post('/orders', orderData),
  verifyPayment: (orderId) => api.get(`/orders/${orderId}/verify-payment`),
  processWompiPayment: (paymentData) => api.post('/orders/process-wompi-payment', paymentData)
};

// Servicios de Productos
export const productsAPI = {
  getAll: (params = {}) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
};

export default api;
